import React from 'react'
import type { FieldsViewProps } from './FieldsView.types'

const FieldsView = ({ children }: FieldsViewProps) => {
  return (
    <div className='container-fluid px-0'>
      <div className='row align-items-end'>{children}</div>
    </div>
  )
}

export default FieldsView
